import {Component, computed, inject, input} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TEMPLATE_STEPS, TemplateDatasource, TemplateStepCode} from '../../../../datasources/template.datasource';
import {CreateTaStep} from '../../../../util/app.types';
import {TimelineStepComponent} from '../../create-ta/create-ta-timeline/timeline-step.component';

@Component({
  selector: 'create-template-timeline',
  imports: [
    TimelineStepComponent
  ],
  templateUrl: './create-template-timeline.html',
})
export class CreateTemplateTimeline {
  private templateDatasource = inject(TemplateDatasource);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  currentStep = input.required<TemplateStepCode>();

  // Shaped for timeline-step. Every step is open: a template is edited in any order.
  steps = computed<CreateTaStep[]>(() => TEMPLATE_STEPS.map(step => ({
    ...step,
    component: null,
    enabled: true,
    valid: this.templateDatasource.stepValid()[step.code],
  })));
  currentIndex = computed<number>(() => TEMPLATE_STEPS.findIndex(step => step.code === this.currentStep()));

  setStep(step: CreateTaStep): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {step: step.code},
      queryParamsHandling: 'merge',
    });
  }
}
